var PCSPHP_TRANSLATIONS_FR = {
	lang: {
		'es': 'Espagnol',
		'en': 'Anglais',
		'fr': 'Français',
		'de': 'Allemand',
		'it': 'Italien',
		'pt': 'Portugais',
	},
	langShort: {
		'es': 'ES',
		'en': 'EN',
		'fr': 'FR',
		'de': 'DE',
		'it': 'IT',
		'pt': 'PT',
	},
	titles: {
		error: 'Erreur',
		success: 'Succès',
		created: 'Créé',
		edited: 'Édité',
	},
	errors: {
		pass_not_match: 'Erreur : les mots de passe doivent correspondre.',
		unexpected_error: 'Une erreur inattendue s\'est produite.',
		unexpected_error_try_later: 'Une erreur inattendue s\'est produite, veuillez réessayer plus tard.',
		name_is_required: 'Le nom est requis.',
		name_should_be_string: 'Le nom doit être une chaîne.',
		lastname_is_required: 'Le prénom est requis.',
		lastname_should_be_string: 'Le prénom doit être une chaîne.',
		email_is_required: 'L\'email est requis.',
		email_should_be_string: 'L\'email doit être une chaîne.',
		user_is_required: 'Le nom d\'utilisateur est requis.',
		user_should_be_string: 'Le nom d\'utilisateur doit être une chaîne.',
		password_is_required: 'Le mot de passe est requis.',
		password_should_be_string: 'Le mot de passe doit être une chaîne.',
	},
	semantic_calendar: {
		days: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
		months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
		monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
		today: 'Aujourd\'hui',
		now: 'Maintenant',
		am: 'AM',
		pm: 'PM',
	},
	semantic_form: {
		text: {
			unspecifiedRule: 'Veuillez entrer une valeur valide',
			unspecifiedField: 'Ce champ'
		},
		prompt: {
			empty: '{name} doit avoir une valeur',
			checked: '{name} doit être coché',
			email: '{name} doit être un email valide',
			url: '{name} doit être une URL valide',
			regExp: '{name} n\'a pas le bon format',
			integer: '{name} doit être un entier',
			decimal: '{name} doit être un nombre décimal',
			number: '{name} doit être un nombre',
			is: '{name} doit être \'{ruleValue}\'',
			isExactly: '{name} doit être exactement \'{ruleValue}\'',
			not: '{name} ne peut pas être \'{ruleValue}\'',
			notExactly: '{name} ne peut pas être exactement \'{ruleValue}\'',
			contain: '{name} ne peut pas contenir \'{ruleValue}\'',
			containExactly: '{name} ne peut pas contenir exactement \'{ruleValue}\'',
			doesntContain: '{name} doit contenir \'{ruleValue}\'',
			doesntContainExactly: '{name} doit contenir exactement \'{ruleValue}\'',
			minLength: '{name} doit contenir au moins {ruleValue} caractères',
			length: '{name} doit contenir au moins {ruleValue} caractères',
			exactLength: '{name} doit contenir exactement {ruleValue} caractères',
			maxLength: '{name} ne peut pas contenir plus de {ruleValue} caractères',
			match: '{name} doit correspondre au champ {ruleValue}',
			different: '{name} doit avoir une valeur différente du champ {ruleValue}',
			creditCard: '{name} doit être un numéro de carte de crédit valide',
			minCount: '{name} doit avoir au moins {ruleValue} choix',
			exactCount: '{name} doit avoir exactement {ruleValue} choix',
			maxCount: '{name} doit avoir {ruleValue} choix ou moins'
		}
	},
	semantic_search: {
		error: {
			logging: "Erreur dans l'enregistrement de débogage, sortie.",
			maxResults: "Les résultats doivent être un tableau pour utiliser la configuration maxResults",
			method: "La méthode que vous avez appelée n'est pas définie.",
			noEndpoint: "Aucun point de terminaison de recherche spécifié",
			noNormalize: "La configuration \"ignoreDiacritics\" sera ignorée. Le navigateur ne prend pas en charge String().normalize(). Vous pouvez envisager d'inclure <https://cdn.jsdelivr.net/npm/unorm@1.4.1/lib/unorm.min.js> comme polyfill.",
			noResults: "Votre recherche n'a donné aucun résultat",
			noResultsHeader: "Aucun résultat",
			noTemplate: "Aucun nom de modèle valide spécifié.",
			oldSearchSyntax: "La configuration searchFullText a été renommée en fullTextSearch pour plus de cohérence, ajustez votre configuration.",
			serverError: "Un problème est survenu lors de la requête au serveur.",
			source: "Impossible de rechercher. Aucune source utilisée et le module API semantic n'a pas été inclus",
		},
	},
	datatables: {
		lang: {
			"decimal": "",
			"emptyTable": "Aucune information disponible",
			"info": "Affichage de _START_ à _END_ sur _TOTAL_ éléments",
			"infoEmpty": "Affichage de 0 à 0 sur 0 éléments",
			"infoFiltered": "(filtré à partir de _MAX_ éléments)",
			"infoPostFix": "",
			"thousands": ".",
			"lengthMenu": "Voir _MENU_ éléments",
			"loadingRecords": "Chargement...",
			"processing": "Traitement...",
			"search": "",
			"searchPlaceholder": "Rechercher...",
			"zeroRecords": "Aucune correspondance trouvée",
			"paginate": {
				"first": "Premier",
				"last": "Dernier",
				"next": "Suivant",
				"previous": "Précédent"
			},
			"aria": {
				"sortAscending": ": activer le tri des colonnes par ordre croissant",
				"sortDescending": ": activer le tri des colonnes par ordre décroissant"
			}
		}
	},
	date: {
		days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		daysLetter: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
		months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
		monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
		today: 'Aujourd\'hui',
		now: 'Maintenant',
		am: 'AM',
		pm: 'PM',
	},
	messenger: {
		'Error': 'Erreur',
		'Ha ocurrido un error desconocido.': 'Une erreur inconnue s\'est produite.',
		'¡Listo!': 'Prêt!',
	},
	loginForm: {
		'Error': 'Erreur',
		'Ha ocurrido un error inesperado, intente más tarde.': 'Une erreur inattendue s\'est produite, veuillez réessayer plus tard.',
		'Si continua con problemas para ingresar, por favor utilice la ayuda.': 'Si vous continuez à avoir des problèmes pour vous connecter, veuillez utiliser l\'aide.',
		'Por favor, verifique los datos de ingreso y vuelva a intentar.': 'Veuillez vérifier les informations de connexion et réessayer.',
		'Por favor, ingrese al siguiente enlace para desbloquear su usuario.': 'Veuillez accéder au lien suivant pour débloquer votre utilisateur.',
		'Se ha presentado un error al momento de ingresar, por favor intente nuevamente.': 'Une erreur s\'est produite lors de la connexion, veuillez réessayer.',
		'CONTRASEÑA_INVÁLIDA': '<span class="mark">Invalide</span> <span class="text">mot de passe</span>',
		'USUARIO_BLOQUEADO': '<span class="text">Utilisateur</span> <span class="mark">bloqué</span>',
		'USUARIO_INEXISTENTE': '<span class="text">L\'utilisateur</span> <span class="mark">%r</span> <span class="text">n\'existe pas</span>',
		'ERROR_AL_INGRESAR': 'Échec de la connexion',
	},
	userProblems: {
		'Será solucionada muy pronto, por favor verifique su correo en las próximas horas. <br> El correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Cela sera résolu très bientôt, veuillez vérifier votre e-mail dans les prochaines heures. <br> L\'e-mail peut se trouver dans "Spam", veuillez vérifier le dossier spam. L\'expéditeur de l\'e-mail est <strong>%r</strong>.',
		'Ingrese el código enviado a su correo, el correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Entrez le code envoyé à votre e-mail, l\'e-mail peut se trouver dans "Spam", veuillez vérifier le dossier spam. L\'expéditeur de l\'e-mail est <strong>%r</strong>.',
		'El correo ingresado no está asociado a ningún usuario, por favor ingrese otra cuenta de correo o puede crear una solicitud de soporte para asociar ese correo a su cuenta.': 'L\'e-mail saisi n\'est associé à aucun utilisateur, veuillez saisir un autre compte e-mail ou vous pouvez créer une demande de support pour associer cet e-mail à votre compte.',
		'El código ingresado está errado, por favor vuelva a ingresar el código, solicite uno nuevo o cree una solicitud de soporte para informar del error.': 'Le code saisi est incorrect, veuillez ressaisir le code, en demander un nouveau ou créer une demande de support pour signaler l\'erreur.',
		'Ingrese con su usuario y la nueva contraseña': 'Connectez-vous avec votre nom d\'utilisateur et le nouveau mot de passe',
		'Las contraseñas no coinciden': 'Les mots de passe ne correspondent pas',
	},
	avatar: {
		'Confirmación': 'Confirmation',
		'¿Seguro de guardar el avatar?': 'Êtes-vous sûr de vouloir enregistrer l\'avatar?',
		'Cargando...': 'Chargement...',
		'¿Seguro de guardar la foto de perfil?': 'Êtes-vous sûr de vouloir enregistrer la photo de profil?',
		'Sí': 'Oui',
		'No': 'Non',
	},
	public: {
		'Ver más': 'Lire la suite',
	}
}
